import { Box, Typography } from '@mui/material';
import { format as formatDate } from 'date-fns';
import { enGB, ru } from 'date-fns/locale';
import { useNormalizedLocale } from 'hooks/useNormalizedLocale';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';

import { PopoverToolbarDatesStyled, PopoverToolbarStyled } from './DatePickerToolbar.styled';

export type DatePickerToolbarProps = {
  title?: string;
  start: number | null;
  end: number | null;
  format?: string;
};

const LOCALES = {
  en: enGB,
  ru: ru,
};

export const DatePickerToolbar: React.FC<DatePickerToolbarProps> = ({
  title,
  start,
  end,
  format = 'd MMMM',
}) => {
  const translate = useTypedTranslate();
  const normalizedLocale = useNormalizedLocale(LOCALES);

  return (
    <PopoverToolbarStyled>
      <Typography variant="overline">
        {title || translate('app.datePicker.dateRangeSelection')}
      </Typography>
      <PopoverToolbarDatesStyled>
        <Box sx={{ display: 'flex' }}>
          <Typography component="h6" variant="h6">
            {start
              ? formatDate(start, format, { locale: normalizedLocale })
              : translate('app.datePicker.rangeStart')}
          </Typography>
          <Typography component="h5" variant="h5">
            &nbsp;–&nbsp;
          </Typography>
          <Typography component="h6" variant="h6">
            {end
              ? formatDate(end, format, { locale: normalizedLocale })
              : translate('app.datePicker.rangeEnd')}
          </Typography>
        </Box>
      </PopoverToolbarDatesStyled>
    </PopoverToolbarStyled>
  );
};
